import api from './api';

/**
 * Area dipendenti.
 *
 * Le rotte di lettura dei documenti e delle ore sono aperte a ogni utente
 * autenticato: il filtro per IDENTITA' lo fa il server, che mostra solo
 * cio' che appartiene a chi chiede. Quelle di gestione sono admin.
 */
export const personaleAPI = {
    dipendenti: (tutti) => api.get('/personale/dipendenti', { params: { tutti } }),
    candidati: () => api.get('/personale/candidati'),
    creaDipendente: (dati) => api.post('/personale/dipendenti', dati),
    aggiornaDipendente: (id, dati) => api.put(`/personale/dipendenti/${id}`, dati),
    // Il PIN torna in chiaro UNA VOLTA e poi non esiste piu': va annotato
    generaPin: (id) => api.post(`/personale/dipendenti/${id}/pin`),

    /* I dispositivi vivono nel modulo della firma: la chiave e' la stessa
       che usano per i moduli, e ne esiste una sola per tablet. */
    dispositivi: () => api.get('/firma-tablet/dispositivi'),
    abilitaTimbratura: (id, usa) =>
        api.put(`/firma-tablet/dispositivi/${id}/timbratura`, { usa_timbratura: usa }),

    documenti: (dipendenteId) =>
        api.get('/personale/documenti', { params: { dipendente_id: dipendenteId } }),
    // Content-Type undefined: il browser calcola il confine del multipart
    caricaDocumento: (formData) =>
        api.post('/personale/documenti', formData, { headers: { 'Content-Type': undefined } }),
    apriDocumento: (id) => api.get(`/personale/documenti/${id}/apri`),
    eliminaDocumento: (id) => api.delete(`/personale/documenti/${id}`),
    accessi: (id) => api.get(`/personale/documenti/${id}/accessi`),
};

/* Buste paga, CU e contratti (migration 341): le gestisce solo chi ha il
   permesso dedicato, e la regola la fa il server su ogni rotta. */
export const bustePagaAPI = {
    stato: () => api.get('/personale/buste-paga/stato'),
    mie: () => api.get('/personale/buste-paga/mie'),
    apri: (id) => api.get(`/personale/buste-paga/${id}/apri`),
    elenco: (params) => api.get('/personale/buste-paga', { params }),
    dipendenti: () => api.get('/personale/buste-paga/dipendenti'),
    cestino: () => api.get('/personale/buste-paga/cestino'),
    carica: (formData) =>
        api.post('/personale/buste-paga', formData, { headers: { 'Content-Type': undefined } }),
    pubblica: (id, corpo) => api.post(`/personale/buste-paga/${id}/pubblica`, corpo || {}),
    togli: (id) => api.delete(`/personale/buste-paga/${id}`),
    ripristina: (id) => api.post(`/personale/buste-paga/${id}/ripristina`),
    accessi: (id) => api.get(`/personale/buste-paga/${id}/accessi`),
};

export const presenzeAPI = {
    /* La timbratura non passa da qui: si fa dal tablet, con la chiave del
       dispositivo e il PIN personale (/api/firma-tablet/timbratura). Qui
       resta solo la consultazione e la gestione del proprio PIN. */
    impostazioni: () => api.get('/presenze/impostazioni'),
    salvaImpostazioni: (dati) => api.put('/presenze/impostazioni', dati),
    statoPin: () => api.get('/presenze/pin'),
    cambiaPin: (pinAttuale, pinNuovo) =>
        api.put('/presenze/pin', { pin_attuale: pinAttuale, pin_nuovo: pinNuovo }),
    stato: () => api.get('/presenze/stato'),
    giornate: (dal, al, dipendenteId) =>
        api.get('/presenze/giornate', { params: { dal, al, dipendente_id: dipendenteId } }),
    timbrature: (dal, al, dipendenteId) =>
        api.get('/presenze/timbrature', { params: { dal, al, dipendente_id: dipendenteId } }),
    /* Il dettaglio di una giornata, solo amministrazione (Alex, 7/10/2026). */
    giornata: (dipendenteId, giorno) =>
        api.get('/presenze/giornata', { params: { dipendente_id: dipendenteId, giorno } }),

    causali: () => api.get('/presenze/causali'),
    assenze: (dal, al, dipendenteId) =>
        api.get('/presenze/assenze', { params: { dal, al, dipendente_id: dipendenteId } }),
    creaAssenza: (dati) => api.post('/presenze/assenze', dati),
    eliminaAssenza: (id) => api.delete(`/presenze/assenze/${id}`),

    /* Ferie e permessi: il dipendente CHIEDE, l'amministrazione DECIDE.
       Sono due rotte diverse e non due parametri della stessa, perche'
       chi le puo' chiamare e' diverso: il dipendente_id della richiesta
       non si legge nemmeno dal corpo, lo decide il server. */
    richiediAssenza: (dati) => api.post('/presenze/assenze/richiesta', dati),
    annullaRichiesta: (id) => api.put(`/presenze/assenze/${id}/annulla`),
    decidiAssenza: (id, stato, motivoRifiuto) =>
        api.put(`/presenze/assenze/${id}/decisione`, { stato, motivo_rifiuto: motivoRifiuto }),
    richiestePendenti: () => api.get('/presenze/assenze/pendenti'),

    /* Le correzioni delle proprie timbrature (Alex, 22/10/2026; migration
       339): come le ferie, la dipendente CHIEDE e l'amministrazione
       DECIDE. Il dipendente non va nel corpo: lo decide il server. */
    richiediCorrezione: (dati) => api.post('/presenze/correzioni/richiesta', dati),
    mieCorrezioni: () => api.get('/presenze/correzioni/mie'),
    /* «Le mie timbrature» (Alex, 28/10/2026): il mese corrente o il
       precedente, sempre di chi ha la sessione. */
    mieTimbrature: (mese) => api.get('/presenze/timbrature/mie', { params: { mese } }),
    ritiraCorrezione: (id) => api.put(`/presenze/correzioni/${id}/annulla`),
    correzioni: (stato) => api.get('/presenze/correzioni', { params: { stato } }),
    decidiCorrezione: (id, dati) => api.put(`/presenze/correzioni/${id}/decisione`, dati),

    straordinari: (dal, al, dipendenteId) =>
        api.get('/presenze/straordinari', { params: { dal, al, dipendente_id: dipendenteId } }),
    autorizzaStraordinario: (dati) => api.post('/presenze/straordinari', dati),
    revocaStraordinario: (id) => api.delete(`/presenze/straordinari/${id}`),

    chiusure: () => api.get('/presenze/chiusure'),
    anteprimaChiusura: (mese) =>
        api.get('/presenze/chiusure/anteprima', { params: { mese } }),
    chiudiMese: (mese) => api.post('/presenze/chiusure', { mese }),
    // Il motivo va nel corpo anche su una DELETE: riaprire un mese gia'
    // mandato allo studio paghe e' una riga che qualcuno chiedera' di spiegare.
    riapriMese: (mese, motivo) =>
        api.delete(`/presenze/chiusure/${mese}`, { data: { motivo } }),

    /* `forza` serve solo quando il mese e' gia' chiuso: senza, il server
       risponde 409 con codice `mese_chiuso`, e la schermata chiede
       conferma prima di rimandare la stessa cosa con forza. La pausa e'
       il punto: chi corregge e' gia' solo l'amministrazione. */
    inserisciTimbratura: (dati) => api.post('/presenze/timbrature', dati),
    correggiTimbratura: (id, dati) => api.put(`/presenze/timbrature/${id}`, dati),
    // Il motivo va nel corpo anche su una DELETE: senza motivo non si annulla
    annullaTimbratura: (id, motivo, forza) =>
        api.delete(`/presenze/timbrature/${id}`, { data: { motivo, forza } }),

    interventi: (dal, al) => api.get('/presenze/interventi', { params: { dal, al } }),
    rifiuti: () => api.get('/presenze/rifiuti'),
    controllo: (dal, al) => api.get('/presenze/controllo', { params: { dal, al } }),
    // Il file arriva come blob: non c'e' un indirizzo pubblico da aprire
    esporta: (dal, al, dipendenti, formato) =>
        api.get('/presenze/export', {
            params: { dal, al, dipendenti, formato }, responseType: 'blob',
        }),
};

export default personaleAPI;
